export default __webpack_public_path__ + "static/media/doug-head.b338c592.png";